import styled from 'styled-components';
import { Link } from 'react-router-dom';
import HidePassword from 'assets/images/hide-password.svg';
import ViewPassword from 'assets/images/view-password.svg';
import { CommonDiv } from 'styles/common';
import { css } from 'styled-components';

const ErrorMessage = styled.div`
  color: ${props => props.theme.color.error};
  font-size: 12px;
  text-align: right;
  margin-top: 2px;
  &:empty {
    margin: 0;
  }
`;

const ForgotLink = styled(CommonDiv.withComponent(Link))`
  text-decoration: none;
  font-weight: 500;
  float: right;
  font-size: 0.875em;
  color: ${props => props.theme.color.primary};
`;

const HidePasswordImg = styled.img.attrs({
  src: HidePassword
})`
  position: absolute;
  right: 10px;
  bottom: 8px;
  cursor: pointer;
  width: 23px;
  height: 23px;
`;

const inputCss = css`
  font-family: 'HelveticaNeue', 'Helvetica Neue', 'Helvetica', 'SF Pro Text', 'Arial', sans-serif;
  outline: none;
  box-sizing: border-box;
  padding: 11px 0px 11px 10px;
  text-align: left;
  width: 100%;
  margin-top: 4px;
  border-radius: 4px;
  background-color: ${props => (props.disabled ? '#f5f5f9' : '#ffffff')};
  font-size: ${props => props.size || 1}em;
  color: ${props => (props.disabled ? props.theme.color.label : props.theme.color.text)};
  padding-right: ${p => p.notPassword ? '11px' : 0};
  border: solid 1px
    ${props =>
    props.active
      ? props.theme.color.primary
      : props.error
        ? props.theme.color.error
        : props.theme.color.border};
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${props => props.theme.color.label};
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${props => props.theme.color.label};
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: ${props => props.theme.color.label};
  }
`;

const Input = styled.input`
  ${inputCss};
  border: solid 1px
    ${props =>
    props.active
      ? props.theme.color.primary
      : props.error
        ? props.theme.color.error
        : props.theme.color.border};
`;

const InputLabel = styled.div`
  color: ${props => props.theme.color.label};
  font-size: ${props => props.size || 0.875}em;
  text-align: left;
  margin-top: ${props => props.top || 0}rem;
`;

const InputNotification = styled.div`
  color: ${props => props.theme.color.primary};
  font-size: 12px;
  text-align: right;
`;

const PasswordBlock = styled.div`
  position: relative;
`;

const Optional = styled.span`
  font-style: italic;
`;

const Required = styled.span`
  color: ${props => props.theme.color.error};
`;

const TextArea = styled.textarea`
  ${inputCss};
  min-height: 4.5em;
  resize: vertical;
`;

const ViewPasswordImg = styled.img.attrs({
  src: ViewPassword
})`
  position: absolute;
  right: 10px;
  bottom: 8px;
  cursor: pointer;
  width: 23px;
  height: 23px;
`;

export {
  ErrorMessage,
  ForgotLink,
  HidePasswordImg,
  Input,
  InputLabel,
  InputNotification,
  PasswordBlock,
  Optional,
  Required,
  TextArea,
  ViewPasswordImg
};
